// extracted by css-extract-rspack-plugin
export default {"link":"link-THjdgV","root":"root-EAnkWz","icon":"icon-jC41O2"};